require("list.js")
require("../scss/_variables.scss")

import List from 'list.js'

document.addEventListener("turbolinks:load", () => {
  const options = {
    valueNames: ['listname'],
    page: 12,
    pagination: true
  };
  const optionsList = new List('results', options);
    
  function updateList(){
    optionsList.update();
    $('ul.pagination li').addClass('page-item');
    $('ul.pagination li a').addClass('page-link');
  }
                                 
  $(function(){
    //updateList();
    optionsList.on('updated', function (list) {
      if (list.matchingItems.length > 0) {
        $('.no-result').hide()
      } else {
        $('.no-result').show()
      }
    });
  });
});
